var content = {"card":"_card_1jpab_1","item":"_item_1jpab_1","header":"_header_1jpab_1 _item_1jpab_1","body":"_body_1jpab_1 _item_1jpab_1","footer":"_footer_1jpab_1 _item_1jpab_1","section":"_section_1jpab_1","section-title":"_section-title_1jpab_1","sectionTitle":"_section-title_1jpab_1"};

export { content as default };
